/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigurationIntegrationTypes } from '../../models/configuration-integration-types';

export interface ConfigurationsIntegrationsGet$Params {
}

export function configurationsIntegrationsGet(http: HttpClient, rootUrl: string, params?: ConfigurationsIntegrationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigurationIntegrationTypes>> {
  const rb = new RequestBuilder(rootUrl, configurationsIntegrationsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfigurationIntegrationTypes>;
    })
  );
}

configurationsIntegrationsGet.PATH = '/configurations/integrations';
